import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const getSpecificTruckData = async ({ seq }) => {
  try {
    const response = await safetyDefaultAPI.get(`truck/${seq}`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getSpecificTruckData;
